import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, MessageCircle, ShieldCheck, Truck, RotateCcw } from "lucide-react";
import { Logo } from "./Header";
import { CATS, subLink } from "../lib/categories";
import { t } from "../lib/i18n";

const POL = [["returns", "Return Policy"], ["refund", "Refund Policy"], ["cancellation", "Cancellation Policy"], ["shipping", "Shipping & Delivery"], ["terms", "Terms of Use"], ["privacy", "Privacy Policy"]];
const head = "text-white font-semibold mb-1";

export default function Footer() {
  return (
    <footer className="relative z-[2] mt-24 border-t border-white/10 bg-[#0c0d13]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-6 grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm text-slate-300 border-b border-white/10">
        <p className="flex items-center gap-2"><Truck size={18} className="text-[#ff5500] shrink-0" />{t("Fast delivery across India")}</p>
        <p className="flex items-center gap-2"><RotateCcw size={18} className="text-[#00f0ff] shrink-0" />{t("Easy returns on eligible items")}</p>
        <p className="flex items-center gap-2"><ShieldCheck size={18} className="text-[#ffb703] shrink-0" />{t("Verified sellers · Cash on Delivery")}</p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 grid gap-10 grid-cols-2 md:grid-cols-6 text-sm text-slate-400">
        <div className="space-y-3 col-span-2">
          <Logo />
          <p className="max-w-sm">{t("EAZYSHOPY is an Indian online marketplace for mobiles, electronics, fashion, home, groceries and more, with multi-view product photos so you know exactly what you get.")}</p>
          <a href="tel:+919032290748" data-testid="footer-phone" className="flex items-center gap-2 hover:text-white"><Phone size={14} />+91 90322 90748</a>
          <a href="https://wa.me/919032290748" target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 hover:text-white"><MessageCircle size={14} />{t("WhatsApp support")}</a>
          <Link to="/help" data-testid="footer-email" className="flex items-center gap-2 hover:text-white"><Mail size={14} />{t("Chat or raise a ticket")}</Link>
          <p className="flex items-center gap-2"><MapPin size={14} />Andhra Pradesh, India</p>
        </div>
        <div className="space-y-2 col-span-2">
          <p className={head}>{t("Shop")}</p>
          <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
            {CATS.map((c) => <Link key={c.slug} to={subLink(c.slug)} data-testid={`footer-shop-${c.slug}`} className="hover:text-white">{t(c.name)}</Link>)}
            <Link to="/products?sort=price_asc" data-testid="footer-shop-deals" className="hover:text-white text-[#ffb703]">{t("Deals")}</Link>
          </div>
        </div>
        <div className="space-y-2">
          <p className={head}>{t("Your account")}</p>
          {[["/about", "About EAZYSHOPY"], ["/orders", "My orders"], ["/wishlist", "Wishlist"], ["/cart", "Cart"], ["/account", "My profile"], ["/grocery-list", "Grocery list"], ["/help", "Help & Support"]].map(([to, n]) => (
            <Link key={to} to={to} data-testid={`footer-link-${to.slice(1)}`} className="block hover:text-white">{t(n)}</Link>
          ))}
        </div>
        <div className="space-y-2">
          <p className={head}>{t("Policies")}</p>
          {POL.map(([k, n]) => <Link key={k} to={`/policies/${k}`} data-testid={`footer-policy-${k}`} className="block hover:text-white">{t(n)}</Link>)}
        </div>
        <div className="space-y-2 col-span-2 md:col-span-6 flex flex-wrap gap-x-6 gap-y-2 pt-6 border-t border-white/10">
          <Link to="/register?role=seller" data-testid="footer-sell" className="hover:text-white">{t("Sell on EAZYSHOPY")}</Link>
          <Link to="/register?role=rider" data-testid="footer-rider" className="hover:text-white">{t("Become a delivery partner")}</Link>
          <span>{t("Payment")}: {t("Cash on Delivery")}</span>
        </div>
      </div>
      <p className="text-center text-xs text-slate-600 pb-6">© {new Date().getFullYear()} EAZYSHOPY. {t("All rights reserved.")}</p>
    </footer>
  );
}
